<script>
	import { getContext } from 'svelte'
	import OwnshipTrail from './ownshipTrail'

	const flight = getContext('flight')
	const trail = flight.getHandler(OwnshipTrail)
</script>